import bridge from '@utiles/bridge';
import globalConfig from '@utiles/globalConfig';
import { getStoreUrlParams } from '@utiles/index';
/* 
  访问页面没有cid, 设置默认cid
  SDK内环境：cid=sdk
  SDK外环境：cid=web
*/
export const handleStoreDefaultCid = () => {
  if (
    globalConfig.getHrefParam('cid') ||
    window.globalIsSrtlUrlParams() ||
    window.location.hash === '#/result'
  ) {
    return;
  }
  const newCid = bridge.runInsdk() ? 'sdk' : 'web';
  let url = globalConfig.hrefAddParam(window.location.href, 'cid', newCid);
  window.location.href = window.globalGetSdkLink({
    link: url,
    inSdk: bridge.runInsdk()
  });
};

export const updateObjScidAndCidOnStoreResult = data => {
  if (!data) return data;
  const storeUrlParams = getStoreUrlParams();
  try {
    data.cid = storeUrlParams?.cid || data?.cid || '';
    data.scid = storeUrlParams?.scid || data?.scid || '';
    return data;
  } catch (e) {
    console.error(e);
    return data;
  }
};
